<template>
  <div class="race-list-page">
    <header-pane pageTitle="ROUNDS" current="race" :hasHeaderNav="hasHeaderNav" />
    <race-list-pane :enabledRaceInfo="false" :enabledRaceListCarousel="true" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/pc/common/Header/HeaderPane.vue'
import RaceListPane from '@/components/RaceListPage/RaceListPane.vue'

/**
 * レース一覧ページ
 */
export default defineComponent({
  name: 'RaceListPage',
  components: {
    HeaderPane,
    RaceListPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.race-list-page {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  min-width: $browserMinWidth;
  min-height: $browserMinHeight;
  background: $black;
}
</style>

<style lang="scss">
.race-list-page {
  .race-list-pane {
    height: 100vh;
    min-height: 600px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: -$headerPaneHeight;
    justify-content: space-between;
    overflow: auto;
    overflow-y: auto;

    @media screen and (max-height: 700px) {
      justify-content: flex-start;
    }

    &::before {
      top: $headerPaneHeight;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
      z-index: 2;
    }

    &::after {
      display: none;
    }

    &__bg {
      position: absolute;
      top: 0;
      left: auto;
      right: 0;
      width: 60%;
      height: calc(100vh - 68px);
      min-height: $browserMinHeight;

      &::after {
        position: absolute;
        top: -$headerPaneHeight;
        left: -1px;
        bottom: 0;
        display: block;
        content: '';
        width: 30vw;
        z-index: 1;
        background: linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
      }
    }

    &__year-select {
      margin-top: $headerPaneHeight;
    }

    &__content {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-end;
      justify-content: center;
      height: calc(100vh - 48px - 44px);
      padding: 0 60px 200px;
      background: none;
      text-align: left;
      overflow-y: auto;
      direction: rtl;
      @include scrollbar();

      @media screen and (max-height: 700px) {
        justify-content: flex-start;
      }

      > * {
        direction: ltr;
      }

      &::after {
        position: fixed;
        left: 0;
        bottom: 0;
        display: block;
        content: '';
        width: 100%;
        height: 236px;
        background: linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px),
          linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px),
          linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px);
        z-index: 3;
        pointer-events: none;
      }
    }

    &__race-list {
      position: fixed;
      left: 0;
      bottom: 0;
      margin-bottom: 0;
      z-index: 4;
    }
  }

  .race-list-header-parts {
    width: 50%;

    &__data {
      color: #fff;

      &::after {
        margin: 20px 0 16px;
        width: 40px;
        height: 2px;
      }
    }

    &__round {
      margin-right: 16px;
      font-size: 18px;
    }

    &__date {
      font-size: 18px;
    }

    &__venue {
      font-size: 40px;
      text-align: left;
      color: #fff;
    }
  }

  .select-race-video-section {
    position: relative;
    width: 50%;
    z-index: 2;

    &__list {
      padding: 4px 0;
      justify-content: flex-start;

      .atom-icon-router-btn,
      .atom-icon-link-btn {
        height: 42px;
        font-size: 15px;
        line-height: 1.33;
      }

      .atom-icon-router-btn {
        img {
          width: 24px;
        }
      }

      &:not(.select-race-video-section__race-info) + .select-race-video-section__list {
        margin-top: 0;
      }
    }
  }

  .select-race-section {
    margin-bottom: 0;

    &__list {
      position: relative;
      align-items: flex-start;
      height: 147px;
      z-index: 2;

      &__item {
        &:first-child {
          margin-left: 50px;
        }
      }

      &::after {
        min-width: 50px;
      }
    }

    .select-race-item-parts {
      width: 168px;
      min-width: 168px;

      &__round {
        height: 60px;

        &__label {
          font-size: 12px;
        }

        &__num {
          font-size: 32px;
        }

        &__course {
          right: 20px;
          bottom: 7px;

          img {
            width: 58px;
          }
        }
      }

      &__data {
        height: 66px;
        padding: 7px 6px;

        &__venue {
          font-size: 14px;
          height: 34px;
          margin-bottom: 4px;
        }

        &__date {
          font-size: 12px;
        }
      }
    }

    @media screen and (max-height: $responsiveMinHeight) {
      margin-bottom: 0;

      &::after {
        min-width: 8px;
      }
    }
  }

  .information-toggle-button-parts {
    position: fixed;
    right: auto;
    left: 0;
    bottom: 165px;
    width: 460px;
    transform: none;
  }

  .race-information-section {
    position: absolute;
    right: auto;
    left: 0;
    bottom: 0;
    width: 460px;
    direction: rtl;
    transform: translate(0, 0);
    padding: 0;
    @include scrollbar();

    opacity: 0;

    > * {
      direction: ltr;
    }

    &__content {
      max-width: 316px;
      margin: 0 auto;
    }
  }

  .common-race-points-card-parts,
  .ranking-card-parts {
    background: rgba($white, 0.2);
  }

  .race-list-pane--show-information {
    .race-list-pane {
      &__bg {
        position: absolute;
        top: 0;
        height: calc(100vh - 68px);
      }

      &__content {
        &::after {
          height: 240px;
        }
      }
    }

    .race-information-section--is-open {
      bottom: 0;
      height: max(100vh, 600px);
      padding: calc(#{$headerPaneHeight} + 48px) 0 280px;
    }
  }

  .race-list-pane--has-information {
    .race-list-pane {
      &__content {
        padding: 0 60px 236px;

        &::after {
          position: fixed;
          bottom: 0;
          height: 236px;
          background: linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px),
            linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px),
            linear-gradient(180deg, rgba(#f7f7f7, 0) 0%, #f7f7f7 122px);
        }
      }

      &__information {
        opacity: 1;
      }
    }
  }
}
</style>
